function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil12{fill:#13b4b6}.fil8{fill:#2e9586}.fil11{fill:#356695}.fil6{fill:#393f95}.fil9{fill:#692d8b}.fil7{fill:#952387}.fil15{fill:#b8d32b}.fil10{fill:#bf0072}.fil5{fill:#ce0948}.fil0{fill:#d4de37}.fil4{fill:#e23a11}.fil13{fill:#e24e0e}.fil14{fill:#e50c12}.fil2{fill:#e77800}.fil3{fill:#ea8a00}.fil1{fill:#f6b200}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Camada_x0020_1"
}, /*#__PURE__*/React.createElement("g", {
  id: "_2243101662352"
}, /*#__PURE__*/React.createElement("path", {
  d: "m442 1270 1 36 8 23c13 4 28 8 42 12l-29-71h-22zM545 1351c3 1 6 1 9 2l3-16h-12v14zM631 1292l-5 67c9 1 18 1 27 1 39 0 76-3 113-9l2-62-70-55-67 58zM853 1285l3 44c31-10 61-21 90-35l1-37-36-23-58 51z",
  className: "fil0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m190 1092-6 79c10 10 21 20 32 29l1-61-12-51-15 4zM368 1055l-1 14 53 165 18 21 12-21-74-181zM592 1049l-10 12-13 27c-12 39-20 87-23 146l46 23 106-23-22-114-84-71zM805 1049l-83 63-24 122 107 38 106-38-20-126zM1063 1128c-19 23-47 44-84 60 9-13 6-34-7-59l-32 12-29 93 68 30 68-30c19-13 36-27 53-42l-4-59-33-5z",
  className: "fil1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M587 1041c-1 3-2 6-3 8l3 2 5-2-1-5-4-3zM752 957l-1-2c-44-9-86-3-121 28l-22 31-16 35 105 29 108-29-22-58-31-34zM810 1005l-5 44 70 41 35-41c-21-21-46-40-72-57l-28 13zM1125 865l-28 47c6 18 10 38 12 57 2 26 1 53-6 80l21 45 100-45c1-2 2-4 4-6l-30-113-73-65z",
  className: "fil2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m193 1049-3 43 9 40 18 7 1-90-9-22zM375 1049l-9-9-6 9 7 20 12 3-3-19z",
  className: "fil3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30 814-17 51 10 6 18-6 6-22-3-20zM1018 680l-37 16 2 44c41 39 74 81 96 125l18 8 28-8-27-121-80-64zM1231 680l-76 59-30 126 107 24 75-24c3-13 6-25 9-38l-11-106-74-41z",
  className: "fil4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m74 680 4 12 11-12 24-91v-15l-5 6z",
  className: "fil5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m650 578 58 82-4 20 8 9 15-9 11-17-85-88z",
  className: "fil6"
}), /*#__PURE__*/React.createElement("path", {
  d: "m853 588 1 7c4 12 8 23 11 31-3-14-5-25-8-36l-4-2zM911 495l-33 26-2 35c28 41 53 90 68 124l37 30 37-30-41-114-66-71zM1125 495l-74 55-33 130 107 23 106-23-29-108zM1260 557l-29 123 74 41 27-41c0-50-6-99-16-146l-56 23z",
  className: "fil5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m592 311-17 13-2 18c17 7 33 14 49 22l-11-39-19-14zM805 311l-59 73-3 34c23 24 42 51 59 77l10 7 10-7-2-4c2 1 4 3 6 4l34 15 51-15-38-118-68-66zM1018 311l-84 61-23 123 111 45 103-45-40-116zM1164 379l-39 116 112 38 69-38c-18-63-45-122-79-176l-63 60z",
  className: "fil7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 250c-16 19-31 40-45 61l25 15 51-15c2-1 3-1 4-1l-5-48-30-12zM272 126l-65 78-41 105c61-19 129-25 201-18l-17-86-78-79zM485 126l-72 68-24 99c29 4 59 10 89 18l58 7 56-7-25-117-82-68zM698 126l-67 71-39 114 124 34 89-34-32-110zM911 126l-76 95-30 90 106 19 107-19-30-99zM1099 170l-49 50-32 91 113 31 91-31c-35-52-76-100-123-141z",
  className: "fil6"
}), /*#__PURE__*/React.createElement("path", {
  d: "m277 117-5 9 111 34 102-34 8-57-58-30c-56 19-109 46-158 78zM628 4c-26 1-51 3-76 7l-43 36-24 79 107 27 106-27-30-88-40-34zM859 35c-31-10-63-17-95-23l-41 26-25 88 104 30 109-30-9-45-43-46zM915 74l-4 52 99 30 33-30c-31-22-64-41-98-57l-30 5z",
  className: "fil8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47 377c33-30 71-52 114-66H85c-14 21-26 43-38 66z",
  className: "fil9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m108 580 4 8 1 1 24-94h-1z",
  className: "fil10"
}), /*#__PURE__*/React.createElement("path", {
  d: "m130 250 35 60 1-1 53-90 53-93h-8c-50 35-95 77-134 124z",
  className: "fil11"
}), /*#__PURE__*/React.createElement("path", {
  d: "m137 495 6-23-7 23z",
  className: "fil7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M224 680v-10l-1 10z",
  className: "fil5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M264 126h8l-2-4c-2 2-4 3-6 4z",
  className: "fil8"
}), /*#__PURE__*/React.createElement("path", {
  d: "m272 126 5-9c-2 2-5 3-7 5l2 4z",
  className: "fil12"
}), /*#__PURE__*/React.createElement("path", {
  d: "m272 126 53 93 42 72c7 0 14 1 22 2l43-74 53-93H272z",
  className: "fil11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M478 311c32 8 64 19 95 31l19-31H478z",
  className: "fil9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m650 578 3-3-18-19z",
  className: "fil6"
}), /*#__PURE__*/React.createElement("path", {
  d: "m485 126 53-92 14-23c-40 6-80 15-117 28l50 87z",
  className: "fil12"
}), /*#__PURE__*/React.createElement("path", {
  d: "m485 126 53 93 54 92 53-92 53-93H592z",
  className: "fil11"
}), /*#__PURE__*/React.createElement("path", {
  d: "m592 311 30 53 12 6c7 3-15-33-8-31 44 14 84 43 117 79l9-15 53-92H592z",
  className: "fil9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M805 495h-3c23 36 40 72 52 100l3-5c-9-30-19-52-35-95h-17zM876 556l35-61h-85c16 14 34 36 50 61z",
  className: "fil10"
}), /*#__PURE__*/React.createElement("path", {
  d: "m628 4 17 30 53 92 54-92 12-22c-36-6-73-9-111-9-8 0-17 0-25 1z",
  className: "fil12"
}), /*#__PURE__*/React.createElement("path", {
  d: "m698 126 54 93 53 92 53-92 53-93H805z",
  className: "fil11"
}), /*#__PURE__*/React.createElement("path", {
  d: "m805 311 53 92 53 92 54-92 53-92H911z",
  className: "fil9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m911 495 54 93 53 92 53-92 54-93h-107z",
  className: "fil10"
}), /*#__PURE__*/React.createElement("path", {
  d: "m911 126 34-57c-28-13-57-25-86-34l52 91z",
  className: "fil12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1018 126H911l54 93 53 92 53-92 28-49c-18-15-36-30-56-44h-25z",
  className: "fil11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1125 311h-107l53 92 54 92 53-92 49-84c-2-3-4-6-5-8h-97z",
  className: "fil9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1231 495h-106l53 93 53 92 53-92 32-54c-3-13-6-26-10-39h-75z",
  className: "fil10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 884c5 16 10 30 16 45l4-8 15-56H13l-7 19z",
  className: "fil13"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30 814 17 29 42-163H74z",
  className: "fil14"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23 933 3-12-4 8z",
  className: "fil2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m208 865-10 128 17-12 5-26 1-90-5-15z",
  className: "fil13"
}), /*#__PURE__*/React.createElement("path", {
  d: "m420 1234 23 72 21-36-14-36z",
  className: "fil15"
}), /*#__PURE__*/React.createElement("path", {
  d: "m216 768-8 97h13l1-87-3-6z",
  className: "fil4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m216 768 3 4 3 6 2-98h-1z",
  className: "fil14"
}), /*#__PURE__*/React.createElement("path", {
  d: "m198 993-5 56h25l2-94-1 2zM338 978l22 71h15l-9-22z",
  className: "fil2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m338 978 28 49-61-151z",
  className: "fil13"
}), /*#__PURE__*/React.createElement("path", {
  d: "m569 1088 23-39h-8c-6 12-10 25-15 39z",
  className: "fil3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M546 1234c-2 31-2 65-1 103l9 16c23 3 47 5 72 6l19-33 53-92H546z",
  className: "fil15"
}), /*#__PURE__*/React.createElement("path", {
  d: "m587 1041 5 8 38-66c-16 14-31 33-43 58z",
  className: "fil13"
}), /*#__PURE__*/React.createElement("path", {
  d: "m592 1049 53 92 53 93 54-93 53-92H698z",
  className: "fil3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m698 1234 54 92 14 25c31-6 61-13 90-22l2-3 53-92H698z",
  className: "fil15"
}), /*#__PURE__*/React.createElement("path", {
  d: "m694 734 33-54h-23z",
  className: "fil6"
}), /*#__PURE__*/React.createElement("path", {
  d: "m752 957 53 92 33-57c-28-17-58-30-87-37l1 2z",
  className: "fil13"
}), /*#__PURE__*/React.createElement("path", {
  d: "m805 1049 53 92 53 93 54-93 7-12c-13-25-35-53-62-80H805z",
  className: "fil3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m911 1234 35 60c36-17 70-37 101-60H911z",
  className: "fil15"
}), /*#__PURE__*/React.createElement("path", {
  d: "M958 716c9 8 17 16 25 24l35-60h-74c8 17 13 30 14 36z",
  className: "fil14"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1097 912 28-47h-46c7 15 14 31 18 47z",
  className: "fil13"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1103 1049c-7 28-19 55-40 79l8 13 29 51c48-42 89-90 124-143h-121z",
  className: "fil3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1018 680 53 92 54 93 53-93 53-92h-106z",
  className: "fil14"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1125 865 53 92 50 86c34-55 61-115 79-178h-182z",
  className: "fil13"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1231 680 53 92 32 55c10-47 16-95 16-145v-2h-101z",
  className: "fil14"
})));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 50.559,
    height: 51.519,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1338 1363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fad788f97dc97a21d0541726b3e4f830.svg";
export { ForwardRef as ReactComponent };